// @flow

// !!! IMPORTANT !!!
//
// This file is shared between the zapier/zapier and zapier/next-js repository.
// Any changes made here should be reflected in there as well.
// For more information, see: https://zapier.quip.com/xaKqAOpdhpY2#ZXFACA8Jnp9
import PropTypes from 'prop-types';
import React from 'react';
import bemify from 'bemify-js';
import createReactClass from 'create-react-class'; // eslint-disable-line no-restricted-syntax

import Img from 'web-ssr/app/common/components/Img';
import { buildStaticAssetPath } from 'web-ssr/app/common/next/utils';
import 'web-ssr/app/common/components/TeamLogo/TeamLogo.scss';

const TeamLogo = createReactClass({
  displayName: 'TeamLogo',

  propTypes: {
    className: PropTypes.string,
    name: PropTypes.string.isRequired,
    size: PropTypes.number.isRequired,
    url: PropTypes.string.isRequired,
  },

  getDefaultProps() {
    return {
      size: 128,
      url: buildStaticAssetPath('images/account-default-image.svg'),
    };
  },

  render() {
    const { props } = this;
    const bem = bemify('team-account-logo');
    return (
      <div className={bem(props.className)}>
        <Img
          alt={`${props.name} logo`}
          className={bem('__image')}
          height={props.size}
          src={props.url}
          width={props.size}
        />
      </div>
    );
  },
});

export default TeamLogo;
